import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';
import axios from 'axios';

/* MODAL */
import { useModal } from 'hooks/modalContext';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* 컴포넌트 */
import CloseBtn from 'components/util/CloseModal';

const ClientQRModal = props => {
  //Modal close
  const { closeModal } = useModal();

  //qr check list
  const [checkedList, setCheckedList] = useState([]);
  const [info, setInfo] = useState({
    qrCodeList: [{
      clientName: '',
      qrName: '',
    }]
  });

  useEffect(() => {
    setInfo(null);

    getQRCodeTotalList();
  }, []);

  //다중 체크
  const multiCheckHandled = (checkThis, item) => {
    if (checkThis.checked) {
      setCheckedList([...checkedList, item]);
    } else {
      setCheckedList(checkedList.filter(el => el.qrCode !== item.qrCode));
    }
  };

  //전체 체크
  const allCheckHandled = (checkThis) => {
    if (checkThis.checked) {
      setCheckedList([...checkedList, ...info?.qrCodeList?.filter(v => checkedList.filter(el => el.qrCode === v.qrCode)?.length === 0)]);
    } else {
      setCheckedList(checkedList.filter(v => info?.qrCodeList?.filter(el => el.qrCode === v.qrCode)?.length === 0));
    }
  };

  const getQRCodeTotalList = () => {
    const custMstSeq = props.props.data.item.custMstSeq;

    Server.sendGet(`client/qr/total/${custMstSeq}`, {}, getQRCodeTotalListCallback).then();
  };

  const getQRCodeTotalListCallback = res => {
    setInfo(res['resultObject']);
  };

  const handleLabel = () => {
    if (!checkedList.length) return;

    const encodedArray = encodeURIComponent(JSON.stringify(checkedList));

    localStorage.setItem('qrList', encodedArray);

    window.open(`/client/qr?clientName=${info?.clientName}`, 'popupWindow', 'width=873, height=600');
  };

  return (
    <>
      <CloseBtn onClick={closeModal}/>
      <div className='modal-box'>
        <div className='inner'>
          <Title>
            <TitHead>
              <i/>
              <h4>Client QRCode List</h4>
            </TitHead>
          </Title>
          <Content>
            <Table>
              <colgroup>
                <col width='5%'/>
                <col width='10%'/>
                <col width='10%'/>
              </colgroup>
              <thead>
              <tr>
                <th>
                  <input
                    id="select-all"
                    name="select-all"
                    type='checkbox'
                    checked={info?.qrCodeList?.filter(v => checkedList.filter(el => el.qrCode === v.qrCode)?.length !== 0)?.length === info?.qrCodeList?.length || false}
                    onChange={e => allCheckHandled(e.target)}
                  />
                  <label htmlFor="select-all"/>
                </th>
                <th>Client</th>
                <th>QR Name</th>
              </tr>
              </thead>
              <tbody>
              {info?.qrCodeList?.map((item, idx) => (
                <tr key={idx}>
                  <td>
                    <input
                      id={`checkbox-${idx}`}
                      name={`checkbox-${idx}`}
                      type='checkbox'
                      checked={checkedList?.find(e => e?.qrCode === item?.qrCode) || false}
                      onChange={e => multiCheckHandled(e.target, item)}
                    />
                    <label htmlFor={`checkbox-${idx}`} />
                  </td>
                  <td>{info.clientName}</td>
                  <td>{item.qrName}</td>
                </tr>
              ))}
              </tbody>
            </Table>
          </Content>
          <FormBtn $Btn>
            <Btn onClick={closeModal}>Cancel</Btn>
            <Btn $Color onClick={handleLabel}>Print Label</Btn>
          </FormBtn>
        </div>
      </div>
    </>
  );
}

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 422px;
  overflow-y: scroll;
`;

const Table = styled.table`
  position: relative;

  & th {
    padding: 10px 0;
    font-weight: 400;
    font-size: 18px;
    color: #777777;
    background: #f8f8f8;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    vertical-align: middle;
  }

  & td {
    padding: 10px 0;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: center;
    vertical-align: middle;
    border-bottom: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;
    height: 47px;
  }
  
  & thead {
    position: sticky;
    top: 0;
  }

  & tbody > tr {
    cursor: pointer;

    &:hover {
      & td {
        background: #f4f4f4;
      }
    }
  }

  & tr td.none-data {
    height: 572px;
    border: 0;
  }

  & tr td:first-child {
    border-left: none;
  }

  & tr:nth-child(even) {
    background: #fcfcfc;
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default ClientQRModal;
